import { ClaimFileGetSignedUrlUseCase } from '../../../application';

export default class ClaimFileGetSignedUrlService {
    constructor() {}

    async execute(event) {
        const request = await ClaimFileGetSignedUrlUseCase(event);

        return request;
    }
}
